import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TempInvoiceEditor.html?raw';
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import EntityStore from '../../moreCore/Tools/EntityStore';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import lang from 'dojo/_base/lang';
import { StringHelpers } from "../../more/Helpers";
import { ExpandableSection, ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import { SelectEntityDialogTypes } from "../../moreCore/_loadingHelpers/SelectEntityDialog";
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import "../../moreCore/UI/SearchSelect/SearchSelect";
import Edit from '../../moreCore/UI/Edit/Edit';
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';
import _GlobalSelectEntityDialogsMixin from '../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../moreCore/UI/HintBox/HintBox';
import { ExistingMusicianPlanningResponse, TempInvoiceEditorBooking, TempInvoiceEditorProgram, TempInvoiceEditorProject, TempInvoiceFinderProject, TempInvoicePresetData, TempInvoiceResidence } from "./TempInvoiceTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import { GenericDialogTypes } from "../../moreCore/UI/GenericDialog/GenericDialogTypes";

class TempInvoiceEditor extends compose(_StatefulSection, _uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private presetData: TempInvoicePresetData;

    private existingMusicianPlanning;

    private headingProject: HTMLHeadingElement;

    private _assignedBookingsStore: MdsLax<InstanceType<typeof EntityStore<TempInvoiceEditorBooking>>>;
    private _assignedBookingsTable: MdsLax<InstanceType<typeof StaticTable>>;

    private _assignedOpusStore: MdsLax<InstanceType<typeof EntityStore<TempInvoiceEditorProgram>>>;
    private _assignedOpusTable: MdsLax<InstanceType<typeof StaticTable>>;

    private _unassignedBookingsStore: MdsLax<InstanceType<typeof EntityStore<TempInvoiceEditorBooking>>>;
    private _unassignedBookingsTable: MdsLax<InstanceType<typeof StaticTable>>;

    private _unassignedOpusStore: MdsLax<InstanceType<typeof EntityStore<TempInvoiceEditorProgram>>>;
    private _unassignedOpusTable: MdsLax<InstanceType<typeof StaticTable>>;

    private assignedBookingsTableExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private unassignedBookingsTableExpander: MdsLax<InstanceType<typeof ExpandableSection>>;

    private assignedBookingsTableContainer: HTMLDivElement;
    private unassignedBookingsTableContainer: HTMLDivElement;

    private assignedOpusTableExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private assignedOpusTableContainer: HTMLDivElement;

    private unassignedOpusTableExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private unassignedOpusTableContainer: HTMLDivElement;

    private btnUnassignAllBookings: HTMLButtonElement;
    private btnUnassignSelectedBookings: HTMLButtonElement;
    private btnAssignAllBookings: HTMLButtonElement;
    private btnAssignSelectedBookings: HTMLButtonElement;

    private btnUnassignAllOpus: HTMLButtonElement;
    private btnUnassignSelectedOpus: HTMLButtonElement;
    private btnAssignAllOpus: HTMLButtonElement;
    private btnAssignSelectedOpus: HTMLButtonElement;

    private btnEditAddress: HTMLButtonElement;
    private btnConfirmAddress: HTMLButtonElement;

    private btnEditBookings: HTMLButtonElement;
    private btnConfirmBookings: HTMLButtonElement;

    private btnEditOpus: HTMLButtonElement;
    private btnConfirmOpus: HTMLButtonElement;

    private sectionBookings: HTMLElement;
    private sectionOpus: HTMLElement;
    private sectionExistingAddress: HTMLElement;
    private sectionNewAddress: HTMLElement;
    private sectionTravel: HTMLElement;
    private sectionTempInformation: HTMLElement;

    private inputIsNewAddress: MdsLax<InstanceType<typeof CheckBox>>;
    private inputEmploymentReason: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputReplacementFor: MdsLax<InstanceType<typeof HintBox>>;
    private inputInstrument: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputFunctionalSubGroup: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputRefTemp: MdsLax<InstanceType<typeof HintBox>>;
    private inputFirstName: MdsLax<InstanceType<typeof Edit>>;
    private inputLastName: MdsLax<InstanceType<typeof Edit>>;
    private inputResidence: MdsLax<InstanceType<typeof RadioGroup>>;
    private inputEmail: MdsLax<InstanceType<typeof Edit>>;
    private inputAdjacentProject: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputIsStayingForAdjacentProject: MdsLax<InstanceType<typeof CheckBox>>;
    //private inputAdjacentProject2: SearchSelect;

    private isConfirmedAddress: boolean = false;
    private isConfirmedBookings: boolean = false;
    private isConfirmedOpus: boolean = false;


    private _bookingTableRowConfig: StaticTable.RowConfig = {
        attributes: [
            "ev_booking_name",
            "ref_ev_activity_status.description",
            "date_start",
            "date_end",
        ],
        colNamesInternal: [
            "ev_booking_name",
            "ref_ev_activity_status.description",
            "date_start",
            "date_end",
        ],
        bgColors: [
            null,
            "ref_ev_activity_status.coloration",
            null,
            null
        ],
        headings: [
            (this as any).translate("TempInvoiceEditor_Label_EvBookingName"),
            (this as any).translate("TempInvoiceEditor_Label_EvBookingStatus"),
            (this as any).translate("TempInvoiceEditor_Label_DateStart"),
            (this as any).translate("TempInvoiceEditor_Label_DateEnd")
        ]
    }

    private _bookingTableLayout: StaticTable.Layout = {
        label: "bookingTable",
        name: "bookingTable",
        rows: [(this as any)._bookingTableRowConfig]
    }

    private _opusTableRowConfig: StaticTable.RowConfig = {
        attributes: [
            "gDisp_1",
        ],
        colNamesInternal: [
            "gDisp_1",
        ],
        headings: [
            (this as any).translate("TempInvoiceEditor_Label_Opus"),
        ]
    }

    private _opusTableLayout: StaticTable.Layout = {
        label: "opusTable",
        name: "opusTable",
        rows: [(this as any)._opusTableRowConfig]
    }

    private _setupBookingTables() {
        this._assignedBookingsTable = new StaticTable();
        this._unassignedBookingsTable = new StaticTable();

        this._assignedBookingsTable.setLayout(this._bookingTableLayout);
        this._unassignedBookingsTable.setLayout(this._bookingTableLayout);

        this._assignedBookingsTable.addCustomRowActionButton("unassign", lang.hitch(this, this._onClickUnassignBooking), "fas fa-minus-circle", null, null, null, lang.hitch(this, this._isBookingTableEnabled), true);
        this._unassignedBookingsTable.addCustomRowActionButton("assign", lang.hitch(this, this._onClickAssignBooking), "fas fa-plus-circle", null, null, null, lang.hitch(this, this._isBookingTableEnabled), true);

        this._assignedBookingsTable.addDefaultRowActionButton("select", null, lang.hitch(this, this._isBookingTableEnabled), true);
        this._unassignedBookingsTable.addDefaultRowActionButton("select", null, lang.hitch(this, this._isBookingTableEnabled), true);

        this._assignedBookingsTable.setupFromStore(this._assignedBookingsStore);
        this._unassignedBookingsTable.setupFromStore(this._unassignedBookingsStore);

        this._assignedBookingsTable.setCyAttribute("TempInvoiceEditorAssignedBookingsTable");
        this._unassignedBookingsTable.setCyAttribute("TempInvoiceEditorUnassignedBookingsTable");

        this._assignedBookingsTable.placeAt(this.assignedBookingsTableContainer);
        this._unassignedBookingsTable.placeAt(this.unassignedBookingsTableContainer);

    }

    private _setupOpusTables() {
        this._assignedOpusTable = new StaticTable();
        this._unassignedOpusTable = new StaticTable();

        this._assignedOpusTable.setLayout(this._opusTableLayout);
        this._unassignedOpusTable.setLayout(this._opusTableLayout);

        this._assignedOpusTable.addCustomRowActionButton("unassign", lang.hitch(this, this._onClickUnassignOpus), "fas fa-minus-circle", null, null, null, lang.hitch(this, this._isOpusTableEnabled), true);
        this._unassignedOpusTable.addCustomRowActionButton("assign", lang.hitch(this, this._onClickAssignOpus), "fas fa-plus-circle", null, null, null, lang.hitch(this, this._isOpusTableEnabled), true);

        this._assignedOpusTable.addDefaultRowActionButton("select", null, lang.hitch(this, this._isOpusTableEnabled), true);
        this._unassignedOpusTable.addDefaultRowActionButton("select", null, lang.hitch(this, this._isOpusTableEnabled), true);

        this._assignedOpusTable.setupFromStore(this._assignedOpusStore);
        this._unassignedOpusTable.setupFromStore(this._unassignedOpusStore);

        this._assignedOpusTable.setCyAttribute("TempInvoiceEditorAssignedOpusTable");
        this._unassignedOpusTable.setCyAttribute("TempInvoiceEditorUnassignedOpusTable");


        this._assignedOpusTable.placeAt(this.assignedOpusTableContainer);
        this._unassignedOpusTable.placeAt(this.unassignedOpusTableContainer);

    }

    private _isBookingTableEnabled(): boolean {
        return !this.isConfirmedBookings;
    }

    private _isOpusTableEnabled(): boolean {
        return !this.isConfirmedOpus;
    }

    private _onClickUnassignBooking(rowGroup: StaticTable.StaticTableRowGroup<TempInvoiceEditorBooking>) {
        let booking = rowGroup.entity;
        this._unassignBooking(booking);
    }

    private _onClickUnassignAllBookings() {
        let entities = this._assignedBookingsStore.getCurrentCompleteList();
        for (let entity of entities) {
            this._unassignBooking(entity);
        }
    }

    private _onClickUnassingSelectedBookings() {
        let selectedEntites = this._assignedBookingsTable.getSelectedEntities() as Array<TempInvoiceEditorBooking>;
        for (let entity of selectedEntites) {
            this._unassignBooking(entity);
        }
    }

    private _unassignBooking(booking: TempInvoiceEditorBooking) {
        this._assignedBookingsStore.deleteEntry(booking);
        this._unassignedBookingsStore.addEntry(booking);
    }

    private _onClickAssignBooking(rowGroup: StaticTable.StaticTableRowGroup<TempInvoiceEditorBooking>) {
        let booking = rowGroup.entity;
        this._assignBooking(booking);
    }

    private _onClickAssignAllBookings() {
        let entities = this._unassignedBookingsStore.getCurrentCompleteList();
        for (let entity of entities) {
            this._assignBooking(entity);
        }
    }

    private _onClickAssignSelectedBookings() {
        let selectedEntites = this._unassignedBookingsTable.getSelectedEntities() as Array<TempInvoiceEditorBooking>;
        for (let entity of selectedEntites) {
            this._assignBooking(entity);
        }
    }

    private _assignBooking(booking: TempInvoiceEditorBooking) {
        this._unassignedBookingsStore.deleteEntry(booking);
        this._assignedBookingsStore.addEntry(booking);
    }

    private _onChangeAssignedBookingsStore() {
        this._setAssignedBookingsExpanderMarking();
        let bookings = this._assignedBookingsStore.getCurrentCompleteList(null, null, true);
        this.setAttributeValue("assignedBookings", bookings);
    }

    private _setAssignedBookingsExpanderMarking() {
        let completeList = this._assignedBookingsStore.getCurrentCompleteList();
        this.assignedBookingsTableExpander.setMarking(completeList.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.empty);
    }

    private _onChangeUnassignedBookingsStore() {
        this._setUnassignedBookingsExpanderMarking();
        let bookings = this._unassignedBookingsStore.getCurrentCompleteList(null, null, true);
        this.setAttributeValue("unassignedBookings", bookings);
    }

    private _setUnassignedBookingsExpanderMarking() {
        let completeList = this._unassignedBookingsStore.getCurrentCompleteList();
        this.unassignedBookingsTableExpander.setMarking(completeList.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.empty);
    }

    //OPUS
    private _onClickUnassignOpus(rowGroup: StaticTable.StaticTableRowGroup<TempInvoiceEditorProgram>) {
        let opus = rowGroup.entity;
        this._unassignOpus(opus);
    }

    private _onClickUnassignAllOpus() {
        let entities = this._assignedOpusStore.getCurrentCompleteList();
        for (let entity of entities) {
            this._unassignOpus(entity);
        }
    }

    private _onClickUnassignSelectedOpus() {
        let selectedEntites = this._assignedOpusTable.getSelectedEntities() as Array<any>;
        for (let entity of selectedEntites) {
            this._unassignOpus(entity);
        }
    }

    private _unassignOpus(opus: TempInvoiceEditorProgram) {
        this._assignedOpusStore.deleteEntry(opus);
        this._unassignedOpusStore.addEntry(opus);
    }

    private _onClickAssignOpus(rowGroup: StaticTable.StaticTableRowGroup<TempInvoiceEditorProgram>) {
        let opus = rowGroup.entity;
        this._assignOpus(opus);
    }

    private _onClickAssignAllOpus() {
        let entities = this._unassignedOpusStore.getCurrentCompleteList();
        for (let entity of entities) {
            this._assignOpus(entity);
        }
    }

    private _onClickAssignSelectedOpus() {
        let selectedEntites = this._unassignedOpusTable.getSelectedEntities() as Array<any>;
        for (let entity of selectedEntites) {
            this._assignOpus(entity);
        }
    }

    private _assignOpus(opus: TempInvoiceEditorProgram) {
        this._unassignedOpusStore.deleteEntry(opus);
        this._assignedOpusStore.addEntry(opus);
    }

    private _onChangeAssignedOpusStore() {
        this._setAssignedOpusExpanderMarking();
        let opus = this._assignedOpusStore.getCurrentCompleteList(null, null, true);
        this.setAttributeValue("assignedOpus", opus);
    }

    private _setAssignedOpusExpanderMarking() {
        let completeList = this._assignedOpusStore.getCurrentCompleteList();
        this.assignedOpusTableExpander.setMarking(completeList.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.empty);
    }

    private _onChangeUnassignedOpusStore() {
        this._setUnassignedOpusExpanderMarking();
        let opus = this._unassignedOpusStore.getCurrentCompleteList(null, null, true);
        this.setAttributeValue("unassignedOpus", opus);
    }

    private _setUnassignedOpusExpanderMarking() {
        let completeList = this._unassignedOpusStore.getCurrentCompleteList();
        this.unassignedOpusTableExpander.setMarking(completeList.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.empty);
    }

    setup(project: TempInvoiceFinderProject, tabContainerName: string, musicianPlanning?: ExistingMusicianPlanningResponse) {
        this.internalName = "tempInvoice_" + project.ID + "_" + StringHelpers.randomID();
        this.headingProject.innerHTML = project.$Displayname;
        this.existingMusicianPlanning = musicianPlanning;
        if (tabContainerName) this.show("tab", this.translate("TempInvoiceEditor_Heading_InvoiceFor") + ": " + project.$Displayname, tabContainerName);
        else this.show("dlg", this.translate("TempInvoiceEditor_Heading_InvoiceFor") + ": " + project.$Displayname, tabContainerName);
        this.setStartupState("loading");
        this.StandbyStart()
        this.RequestManager.callfunction("Webtool_API__TempInvoiceEditor_LoadData", { entityId: project.ID }, lang.hitch(this, this._onLoadDataResponse), lang.hitch(this, this._onLoadDataError))
    }

    private _onLoadDataResponse(response: TempInvoiceEditorProject) {
        this.setStartupState("ready");
        this.StandbyStop();
        this.setData(response);
        this._loadFunctionalGroups();
    }

    private _onLoadDataError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _onClickEditAddressBtn() {
        this.isConfirmedAddress = false;
        this.disableNode(this.btnEditAddress);
        this.disableNode(this.btnConfirmAddress, false);

        this._resetTempInfoSection();
        this._resetBookingsSection();

        this.rollback();
        this.removeButton("delete");

    }

    private _resetTempInfoSection() {
        this.hideNode(this.sectionTempInformation, true);
        this.setAttributeValue("is_academy_employment", false);
        this.setAttributeValue("replacementReason", null);
        this.setAttributeValue("replacementFor", null);
        this.setAttributeValue("residence", null);
        this.setAttributeValue("arrival_from", null);
        this.setAttributeValue("return_back_to", null);
        this.setAttributeValue("date_arrival", null);
        this.setAttributeValue("date_departure", null);
        this.setAttributeValue("position", null);
        this.setAttributeValue("is_hotel_needed", false);
        this.setAttributeValue("landline", null);
        this.setAttributeValue("mobile", null);
        this.setAttributeValue("email", null);
        this.setAttributeValue("ref_adjacent_ev_project", null);
    }

    private _resetBookingsSection() {
        this._disableAddressSection(false);

        this._assignedBookingsStore = new EntityStore();
        this._unassignedBookingsStore = new EntityStore();
        this._assignedBookingsTable.setupFromStore(this._assignedBookingsStore);
        this._unassignedOpusTable.setupFromStore(this._unassignedBookingsStore);
        this.hideNode(this.sectionBookings, true);
        this.unassignedBookingsTableExpander.toggleExpand(false);
        this.assignedBookingsTableExpander.toggleExpand(true);
        this.isConfirmedBookings = false;
        this.disableNode(this.btnEditBookings);
        this.disableNode(this.btnConfirmBookings, false);
        this.setAttributeValue("assignedBookings", null);

        this._resetOpusSection();
    }


    private _onClickConfirmAddressBtn() {
        if (!this.inputInstrument.getValue() || !this.inputInstrument.getValue()) {
            this.showToast(this.translate("TempInvoiceEditor_Error_ConfirmAddress"), "fas fa-exclamation-triangle");
            return;
        }

        let isNewAddress = this.getAttributeValue("is_new_address");
        if (isNewAddress) {
            if (!this.inputFirstName.getValue() || !this.inputLastName.getValue()) {
                this.showToast(this.translate("TempInvoiceEditor_Error_ConfirmAddress"), "fas fa-exclamation-triangle");
                return;
            }
        } else {
            if (!this.inputRefTemp.getValue()) {
                this.showToast(this.translate("TempInvoiceEditor_Error_ConfirmAddress"), "fas fa-exclamation-triangle");
                return;
            }
        }



        if (isNewAddress) {
            let bookings = this.getAttributeValue("EL_ev_booking_ev_project");
            this._assignedBookingsStore.setup(bookings);
            let bookingIds = this._assignedBookingsStore.getCurrentCompleteList(null, null, true);
            this.setAttributeValue("assignedBookings", bookingIds);

            this._showBookingsSection();
        } else {
            this.StandbyStart();
            this.RequestManager.callfunction(
                "Webtool_API__TempInvoiceEditor_LoadExistingMusicianPlanning",
                {
                    projectId: this.getAttributeValue("ID"),
                    functionalGroup: this.getAttributeValue("ref_functional_group"),
                    functionalSubGroup: this.getAttributeValue("ref_functional_sub_group"),
                    substitute: this.getAttributeValue("ref_temp")
                },
                lang.hitch(this, this._onLoadExistingMusicianPlanningResponse),
                lang.hitch(this, this._onLoadExistingMusicianPlanningError)
            );
        }

    }

    private _disableAddressSection(disable: boolean = true) {
        this.inputIsNewAddress.setReadonly(disable);
        this.inputRefTemp.setReadonly(disable);
        this.inputFirstName.setReadonly(disable);
        this.inputLastName.setReadonly(disable);
        this.inputInstrument.setReadonly(disable);
        this.inputFunctionalSubGroup.setReadonly(disable);
    }

    private _showBookingsSection() {
        this._disableAddressSection();

        let hasExisitingMusicianPlanning = this.getAttributeValue("hasExistingMusicianPlanning");

        this.isConfirmedAddress = true;
        this.disableNode(this.btnConfirmAddress);
        this.disableNode(this.btnEditAddress, false || hasExisitingMusicianPlanning || this.presetData);

        this._setAssignedBookingsExpanderMarking();
        this._setUnassignedBookingsExpanderMarking();

        this.hideNode(this.sectionBookings, false);
        //this.hideNode(this.sectionTempInformation, false);
    }

    private _onLoadExistingMusicianPlanningResponse(response: ExistingMusicianPlanningResponse ) {
        this.StandbyStop();

        let hasExistingMusicianPlanning = response.hasExistingMusicianPlanning;
        this.setAttributeValue("hasExistingMusicianPlanning", response.hasExistingMusicianPlanning);

        if (hasExistingMusicianPlanning) {
            this.showToast(this.translate("TempInvoiceEditor_Message_ExistingMusicianPlanning"), "fas fa-check");
            let bookings = this.getAttributeValue("EL_ev_booking_ev_project");
            this._unassignedBookingsStore.setup(bookings);
            let bookingIds = this._unassignedBookingsStore.getCurrentCompleteList(null, null, true);
            this.setAttributeValue("unassignedBookings", bookingIds);
            for (let booking of response.bookings) {
                this._assignBooking(booking);
            }
            let opus = response.opus;
            let isAcademyService = response.isAcademyService;
            let replacementReason = response.replacementReason;
            let replacementFor = response.replacementFor;
            let adjacentProject = response.adjacentProject;
            let isStayingForAdjacentProject = response.is_staying_for_adjacent_project;
            let musicianPlanning = response.musicianPlanning;
            let arrival_from = response.arrival_from;
            let return_back_to = response.return_back_to;
            let is_hotel_needed = response.is_hotel_needed;
            let date_arrival = response.date_arrival;
            let date_departure = response.date_departure;
            let position = response.position;
            let residenceValue = response.residence;
            let residence = TempInvoiceResidence[residenceValue];
            //switch (residenceValue) {
            //    case 1:
            //        residence = "berlin";
            //        break;
            //    case 2:
            //        residence = "germany";
            //        break;
            //    case 3:
            //        residence = "international";
            //        break;
            //}
            //this.setAttributeValue("assignedOpus", opus);
            this.setAttributeValue("originalOpus", opus);
            this.setAttributeValue("is_academy_employment", isAcademyService);
            this.setAttributeValue("replacementReason", replacementReason);
            this.setAttributeValue("replacementFor", replacementFor);
            this.setAttributeValue("is_staying_for_adjacent_project", isStayingForAdjacentProject);
            this.setAttributeValue("ref_adjacent_ev_project", adjacentProject);
            this.setAttributeValue("musicianPlanning", musicianPlanning);
            this.setAttributeValue("arrival_from", arrival_from);
            this.setAttributeValue("return_back_to", return_back_to);
            this.setAttributeValue("is_hotel_needed", is_hotel_needed);
            this.setAttributeValue("date_arrival", date_arrival);
            this.setAttributeValue("date_departure", date_departure);
            this.setAttributeValue("position", position);
            this.setAttributeValue("residence", residence);

            this._onClickConfirmBookingsBtn(null, true);
        } else {
            this.showToast(this.translate("TempInvoiceEditor_Message_NoExistingMusicianPlanning"), "fas fa-times");
            let bookings = this.getAttributeValue("EL_ev_booking_ev_project");
            this._assignedBookingsStore.setup(bookings);
            let bookingIds = this._assignedBookingsStore.getCurrentCompleteList(null, null, true);
            this.setAttributeValue("assignedBookings", bookingIds);

            if (this.presetData) {
                this.setAttributeValue("arrival_from", this.presetData.arrival_from );
                this.setAttributeValue("return_back_to", this.presetData.return_back_to);
                this.setAttributeValue("is_hotel_needed", this.presetData.is_hotel_needed);
                this.setAttributeValue("date_arrival", this.presetData.date_arrival);
                this.setAttributeValue("date_departure", this.presetData.date_departure);
                this.setAttributeValue("residence", this.presetData.residence);
            }
        }
        this._showBookingsSection();
    }

    private _onLoadExistingMusicianPlanningError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _onClickEditBookingsBtn() {
        this.disableNode(this.btnConfirmBookings, false);
        this.disableNode(this.btnEditBookings, true);
        this.isConfirmedBookings = false;
        this._disableBookingTableButtons(this.isConfirmedBookings);
        this._assignedBookingsTable.updateTable();
        this._unassignedBookingsTable.updateTable();
        this.assignedBookingsTableExpander.toggleExpand(true);
        this.unassignedBookingsTableExpander.toggleExpand(false);

        this._resetOpusSection();
    }

    private _showOpusSection() {
        let hasExistingMusicianPlanning = this.getAttributeValue("hasExistingMusicianPlanning")

        this.disableNode(this.btnConfirmBookings);
        this.disableNode(this.btnEditBookings, false);
        this.isConfirmedBookings = true;
        this._disableBookingTableButtons(this.isConfirmedBookings);
        this._assignedBookingsTable.updateTable();
        this._unassignedBookingsTable.updateTable();
        this.assignedBookingsTableExpander.toggleExpand(false);
        this.unassignedBookingsTableExpander.toggleExpand(hasExistingMusicianPlanning);

        this.hideNode(this.sectionOpus, false);
    }

    private _onClickConfirmBookingsBtn(event: MouseEvent, resetDirty: boolean = false) {
        this._showOpusSection();

        let autoConfirmBookings: boolean = !event;

        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API__TempInvoiceEditor_LoadRelatedOpusData",
            { evBookings: this._assignedBookingsStore.getCurrentCompleteList() },
            lang.hitch(this, this._onLoadRelatedOpusDataResponse, resetDirty, autoConfirmBookings),
            lang.hitch(this, this._onLoadRelatedOpusDataError)
        );
    }

    private _onLoadRelatedOpusDataResponse(resetDirty: boolean = false, autoConfirmBookings: boolean = true, response: Array<TempInvoiceEditorProgram>) {
        this.StandbyStop();
        if (this.getAttributeValue("hasExistingMusicianPlanning")) {
            this._unassignedOpusStore.setup(response);
            let originalOpusList = this.getAttributeValue("originalOpus");
            let assignedOpusList = [];
            let unassignedOpusList = response;
            for (let opus of originalOpusList) {
                if (this._unassignedOpusStore.getEntityById(opus.ID)) {
                    //So gelöst, damit kein store change event ausgelöst wird, weil das erst nach dem resetDirty verarbeitet wird
                    assignedOpusList.push(opus);
                    unassignedOpusList = unassignedOpusList.filter((currentOpus) => { currentOpus.ID !== opus.ID });
                    //this._assignOpus(opus);
                }
            }
            this._assignedOpusStore.setup(assignedOpusList);
            this._unassignedOpusStore.setup(unassignedOpusList);

            if(autoConfirmBookings) this._onClickConfirmOpusBtn();
            if(resetDirty) this.resetDirty();
            this.createDefaultButton("deleteWithConfirmationDlg", lang.hitch(this, this._onClickDeleteBtn));
        } else {
            this._assignedOpusStore.setup(response);
            let opusIds = this._assignedOpusStore.getCurrentCompleteList(null, null, true);
            this.setAttributeValue("assignedOpus", opusIds);
        }

        this._setUnassignedOpusExpanderMarking();
        this._setAssignedOpusExpanderMarking();
    }

    private _onLoadRelatedOpusDataError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _onClickDeleteBtn() {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API__TempInvoiceEditor_DeleteData",
            this.getAttributeValue("musicianPlanning"),
            lang.hitch(this, this._onDeleteResponse),
            lang.hitch(this, this._onDeleteError)
        );
    }

    private _onDeleteResponse(response) {
        this.StandbyStop();
        this.showToast(this.translate("TempInvoiceEditor_Message_DeleteSuccess"), "fas fa-check");
        this.emit("saved");
        this.close();
    }

    private _onDeleteError(error) {
        this.StandbyStop
        this.showToast(error.Message, "fas-fa-exclamation-triangle");
        console.error(error);
    }

    private _resetOpusSection() {
        this._assignedOpusStore = new EntityStore();
        this._unassignedOpusStore = new EntityStore();
        this._assignedOpusTable.setupFromStore(this._assignedOpusStore);
        this._unassignedOpusTable.setupFromStore(this._unassignedOpusStore);
        this.hideNode(this.sectionOpus, true);
        this.unassignedOpusTableExpander.toggleExpand(false);
        this.assignedOpusTableExpander.toggleExpand(true);
        this.isConfirmedOpus = false;
        this.disableNode(this.btnEditOpus);
        this.disableNode(this.btnConfirmOpus, false);
        this.setAttributeValue("assignedOpus", null);
        this.requestContextButtonDisable("save", true);
        this.hideNode(this.sectionTempInformation, true);
    }

    private _disableBookingTableButtons(disable: boolean = true) {
        this.disableNode(this.btnAssignAllBookings, disable);
        this.disableNode(this.btnAssignSelectedBookings, disable);
        this.disableNode(this.btnUnassignAllBookings, disable);
        this.disableNode(this.btnUnassignSelectedBookings, disable);
    }

    private _onClickEditOpusBtn() {
        this.disableNode(this.btnConfirmOpus, false);
        this.disableNode(this.btnEditOpus, true);
        this.isConfirmedOpus = false;
        this._disableOpusTableButtons(this.isConfirmedOpus);
        this._assignedOpusTable.updateTable();
        this._unassignedOpusTable.updateTable();
        this.assignedOpusTableExpander.toggleExpand(true);
        this.unassignedOpusTableExpander.toggleExpand(false);
        this.requestContextButtonDisable("save", true);
        this.hideNode(this.sectionTempInformation, true);
    }

    private _onClickConfirmOpusBtn() {
        this.disableNode(this.btnConfirmOpus);
        this.disableNode(this.btnEditOpus, false);
        this.isConfirmedOpus = true;
        this._disableOpusTableButtons(this.isConfirmedOpus);
        this._assignedOpusTable.updateTable();
        this._unassignedOpusTable.updateTable();
        this.assignedOpusTableExpander.toggleExpand(false);
        this.unassignedOpusTableExpander.toggleExpand(false);
        this.requestContextButtonDisable("save", !this.isDirty());
        this.hideNode(this.sectionTempInformation, false);
        this.sectionTempInformation.scrollIntoView();
    }

    private _disableOpusTableButtons(disable: boolean = true) {
        this.disableNode(this.btnAssignAllOpus, disable);
        this.disableNode(this.btnAssignSelectedOpus, disable);
        this.disableNode(this.btnUnassignAllOpus, disable);
        this.disableNode(this.btnUnassignSelectedOpus, disable);
    }

    private _onChangeIsNewAddress(value: boolean) {
        this.hideNode(this.sectionNewAddress, !value);
        this.hideNode(this.sectionExistingAddress, value);
        //this.hideNode(this.sectionPlaceOfLiving, value);
    }

    protected onDirtyChange(newState: boolean) {
        this.requestContextButtonDisable("save", !newState || !this.isConfirmedOpus);
        this._handleOpenAdjacentProjectButtonState();
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        this.setAttributeValue("is_new_address", false);
        this.setAttributeValue("ref_temp", null);
        this.setAttributeValue("first_name", "");
        this.setAttributeValue("last_name", "");
        this.setAttributeValue("ref_functional_group", null);
        this.setAttributeValue("ref_functional_sub_group", null);
        this.setAttributeValue("is_academy_employment", false);
        this.setAttributeValue("replacementReason", null);
        this.setAttributeValue("replacementFor", null);
        this.setAttributeValue("residence", null);
        this.setAttributeValue("arrival_from", "");
        this.setAttributeValue("return_back_to", "");
        this.setAttributeValue("date_arrival", null);
        this.setAttributeValue("date_departure", null);
        this.setAttributeValue("position", null);
        this.setAttributeValue("is_hotel_needed", false);
        this.setAttributeValue("landline", "");
        this.setAttributeValue("mobile", "");
        this.setAttributeValue("email", "");
        this.setAttributeValue("ref_adjacent_ev_project", null);
        this.setAttributeValue("is_staying_for_adjacent_project", null);

        this.inputAdjacentProject.setRequestParameter("date_to", this.getAttributeValue("date_to"));
        this.inputReplacementFor.addAdditionalRequestParameter("functional_sub_group", this.getAttributeValue("ref_functional_sub_group"));
    }

    protected _onChanged(attribute: string, value: any) {
        switch (attribute) {
            case "residence":
                let hideSectionTravel = value === "berlin" || !value;
                this.hideNode(this.sectionTravel, hideSectionTravel);
                break;
            case "is_new_address":
                if (value) this.setAttributeValue("ref_temp", null);
                break;
            case "ref_adjacent_ev_project":
                //this.inputIsStayingForAdjacentProject.setReadonly(!value);
                break;
            case "is_staying_for_adjacent_project":
                this.inputAdjacentProject.setRequestParameter("isStayingForAdjacentProject", value);
                this._onChangeIsStayingForAdjacentProject(value);
                break;
        }
    }

    private _onChangeIsStayingForAdjacentProject(isStaying: boolean = false) {
        this.inputAdjacentProject.setRequestParameter("isStayingForAdjacentProject", isStaying);
        this.inputAdjacentProject.loadListValues(null);
    }

    private _onLoadAdjacentProjectValues(): void {
        let project = this.getAttributeValue("ref_adjacent_ev_project");
        if (project) {
            let values = this.inputAdjacentProject.getAllValues();
            if (values.find((current) =>  current["value"] == project.ID ) ) this.inputAdjacentProject.setValue(project);
            else this.setAttributeValue("ref_adjacent_ev_project", null);
        }
    }

    private _loadAdjacentProjectValues(): void {
        this.StandbyStart();
            
    }

    private _onLoadAjacentProjectValuesResponse(response: Array<any>) {
        this.StandbyStop();
    }

    private _onLoadAjacentProjectValuesError(error: more.requestErrorMessage) {
        this.StandbyStop();
    }

    private _onClickSEDButton(mode: string, evt) {
        let data = {};
        if (mode === "project") {
            data["date_to"] = this.getAttributeValue("date_to");
            data["isStayingForAdjacentProject"] = this.getAttributeValue("is_staying_for_adjacent_project");
        }
        if (mode === "replacement") data["functional_sub_group"] = this.getAttributeValue("ref_functional_sub_group");

        this.loadSelectEntityDialog(evt, mode, lang.hitch(this, this._onSEDCallback), null, data);
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<any>>) {
        switch (mode) {
            case "replacement":
                if (!items || !(items.length > 0)) return;
                var entity = items[0].entry.data;
                this.setAttributeValue("replacementFor", entity);
                break;
            case "temp":
                if (!items || !(items.length > 0)) return;
                var entity = items[0].entry.data;
                this.setAttributeValue("ref_temp", entity);
                break;  
            case "project":
                if (!items || !(items.length > 0)) return;
                var entity = items[0].entry.data;
                this.setAttributeValue("ref_adjacent_ev_project", entity);
                break;
        }
    }

    private _onChangeRefTemp() {
        let entity = this.inputRefTemp.getValue("entity");

        if (entity) {
            let residence;
            if (entity.c_city) residence = entity.c_city.toLowerCase() === "berlin" ? "berlin" : entity.ref_country.description.toLowerCase() === "germany" ? "germany" : "international";
            else residence = "berlin";
            //this.setAttributeValue("residence", residence);
            if (entity.ref_person && entity.ref_person.ref_telecomm_mobile_01) this.setAttributeValue("landline", entity.ref_person.ref_telecomm_mobile_01?.telecom_code);
            if (entity.ref_person && entity.ref_person.ref_telecomm_phone_01) this.setAttributeValue("mobile", entity.ref_person.ref_telecomm_phone_01?.telecom_code);
            if (entity.ref_person && entity.ref_person.ref_telecomm_email_01) this.setAttributeValue("email", entity.ref_person.ref_telecomm_email_01?.telecom_code);
        } else {
            this.setAttributeValue("residence", null);
            this.setAttributeValue("landline", "");
            this.setAttributeValue("mobile", "");
            this.setAttributeValue("email", "");
        }
    }

    private _onChangeFunctionalSubGroup() {
        this.inputReplacementFor.addAdditionalRequestParameter("functional_sub_group", this.inputFunctionalSubGroup.getValue(true));
    }

    private _onChangeInstrument() {
        let instrument = this.inputInstrument.getValue(true);
        if (instrument) {
            let presetValue;
            if (this.existingMusicianPlanning && !this.getAttributeValue("hasExistingMusicianPlanning")) presetValue = this.existingMusicianPlanning.ref_functional_sub_group;
            else if (this.presetData) presetValue = this.presetData.functionalSubGroup;
            this.inputFunctionalSubGroup.setData(presetValue, instrument.EL_functional_sub_group_functional_group);
            this.inputFunctionalSubGroup.setReadonly(false);
        } else {
            this.inputFunctionalSubGroup.setValue(null);
            this.inputFunctionalSubGroup.setOptions([], []);
            this.inputFunctionalSubGroup.setReadonly(true);
        }
    }

    private _isMandatoryValid(): boolean {

        if (!this.inputEmploymentReason.getValue()) return false;
        if (!this.inputInstrument.getValue()) return false;
        if (!this.inputFunctionalSubGroup.getValue()) return false;
        if (!this.inputEmail.getValue()) return false;

        let isNewAddress = this.getAttributeValue("is_new_address");
        if (isNewAddress) {
            if (!this.inputFirstName.getValue()) return false;
            if (!this.inputLastName.getValue()) return false;
        } else {
            if (!this.inputRefTemp.getValue()) return false;
        }


        return true;
    }

    private _onClickSave() {
        if (!this.isConfirmedBookings || !this.isConfirmedOpus) {
            this.showToast(this.translate("TempInvoiceEditor_Error_ConfirmBookings"), "fas fa-excalamtion-triangle");
            return;
        }

        if (!this._isMandatoryValid()) {
            this.showToast(this.translate("TempInvoiceEditor_Errror_MandatoryInput"), "fas fa-excalamtion-triangle");
            return;
        }

        let data = this.getCurrentData();
        delete data.EL_ev_booking_ev_project;

        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API__TempInvoiceEditor_SaveData",
            { data: this.getCurrentData() },
            lang.hitch(this, this._onSaveResponse),
            lang.hitch(this, this._onSaveError)
        );
    }

    private _onSaveResponse(response) {
        this.StandbyStop();
        this.showToast({
            title: this.translate("TempInvoiceEditor_Message_SaveSuccess"),
            iconClass: "fas fa-check",
            timeout: 1500
        });
        //Hat keinen Grund außer UX, damit nicht drei schnelle UI Wechsel in Folge passieren
        setTimeout(lang.hitch(this, this.openAdjacentProjectEditor, true), 1200);
    } 

    private _onSaveError(error) {
        this.StandbyStop();
        this.showToast(error.Message, "fas fa-exclamation-triangle");
        console.error(error);
    }

    setPresetData(data: TempInvoicePresetData) {
        this.presetData = data;
    }

    private _handleOpenAdjacentProjectButtonState() {
        //this.inputAdjacentProject.disableInlineButton("openProject", this.isDirty() || !this.isConfirmedOpus || !this.getAttributeValue("ref_adjacent_ev_project"));
    }

    private _onClickOpenAdjacentProjectButton() {
        if (this.isDirty() || !this.isConfirmedOpus || !this.inputAdjacentProject.getValue()) return;

        let dlg = new GenericDialog();
        dlg.setup(
            {
                buttonPreset: "yesno",
                callbackConfig: {
                    yesCallback: lang.hitch(this, this.openAdjacentProjectEditor, true)
                },
                content: "TempInvoiceEditor_Warning_CloseEditor",
                header: "TempInvoiceEditor_Title_OpenAdjacentEditor",
                contentIconClass: GenericDialogTypes.DialogIcon.warning
            }
        );
    }

    private openAdjacentProjectEditor(closeOnOpen: boolean = false) {
        if (closeOnOpen) {
            this.close();
        }

        let adjacentProject = this.getAttributeValue("ref_adjacent_ev_project");

        if (!adjacentProject) {
            this.emit("saved");
            return;
        }

        let presetData: TempInvoicePresetData = {
            temp: this.getAttributeValue("ref_temp"),
            functionalMainGroup: this.getAttributeValue("ref_functional_group"),
            functionalSubGroup: this.getAttributeValue("ref_functional_sub_group")
        }

        let isStayingForAdjacentProject = this.getAttributeValue("is_staying_for_adjacent_project");
        if (isStayingForAdjacentProject) {
            presetData.residence = this.getAttributeValue("residence");
            presetData.arrival_from = this.getAttributeValue("arrival_from");
            presetData.date_arrival = this.getAttributeValue("date_arrival");
            presetData.return_back_to = this.getAttributeValue("return_back_to");
            presetData.date_departure = this.getAttributeValue("date_departure");
            presetData.is_hotel_needed = this.getAttributeValue("is_hotel_needed");
        }

        if (adjacentProject) {
            let adjacentProjectEditor = new TempInvoiceEditor();
            adjacentProjectEditor.setPresetData(presetData);
            adjacentProjectEditor.setup(adjacentProject, this.getTabContainerName(), null);
            adjacentProjectEditor.on("saved", lang.hitch(this, this.emit, "saved"));
        }
    }

    private _loadExistingMusicianData() {
        if (this.existingMusicianPlanning) {
            this.inputRefTemp.setValue(this.existingMusicianPlanning.ref_associate);
            //this.setAttributeValue("ref_temp", this.existingMusicianPlanning.ref_associate);
            this._onClickConfirmAddressBtn();
        }
        else if (this.presetData) {
            this.inputRefTemp.setValue(this.presetData.temp);
            this._onClickConfirmAddressBtn();
        }
    }

    private _loadFunctionalGroups() {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API__TempInvoiceEditor_GetFunctionalMainGroups",
            {},
            lang.hitch(this, this._onLoadFunctionalGroupsResponse),
            lang.hitch(this, this._onLoadFunctionalGroupsError),
        );
    }

    private _onLoadFunctionalGroupsResponse(response) {
        this.StandbyStop();
        let presetValue;

        if (this.existingMusicianPlanning) presetValue = this.existingMusicianPlanning.ref_functional_group;
        else if (this.presetData) presetValue = this.presetData.functionalMainGroup;
        this.inputInstrument.setData(null, response, true);
        this.setAttributeValue("ref_functional_group", presetValue);


        if (this.existingMusicianPlanning) presetValue = this.existingMusicianPlanning.ref_functional_sub_group;
        else if (this.presetData) presetValue = this.presetData.functionalSubGroup;
        this.setAttributeValue("ref_functional_sub_group", presetValue);


        this._loadExistingMusicianData();
    }

    private _onLoadFunctionalGroupsError(error) {
        this.StandbyStop();
        console.error(error);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._assignedBookingsStore = new EntityStore();
        this._unassignedBookingsStore = new EntityStore();

        this._assignedOpusStore = new EntityStore();
        this._unassignedOpusStore = new EntityStore();

        this._assignedBookingsStore.on("change", lang.hitch(this, this._onChangeAssignedBookingsStore));
        this._unassignedBookingsStore.on("change", lang.hitch(this, this._onChangeUnassignedBookingsStore));

        this._assignedOpusStore.on("change", lang.hitch(this, this._onChangeAssignedOpusStore));
        this._unassignedOpusStore.on("change", lang.hitch(this, this._onChangeUnassignedOpusStore));

        this._setupBookingTables()
        this._setupOpusTables();

        this.disableNode(this.btnEditAddress);
        this.disableNode(this.btnEditBookings);
        this.disableNode(this.btnEditOpus);

        this.SEDconfigCallfunction = "Webtool_API__TempInvoiceEditor_SED_GetConfig";

        this.inputReplacementFor.addInlineButton(lang.hitch(this, this._onClickSEDButton, "replacement"));
        this.inputRefTemp.addInlineButton(lang.hitch(this, this._onClickSEDButton, "temp"));

        //this.inputAdjacentProject.addInlineButton(lang.hitch(this, this._onClickSEDButton, "project"));
        //this.inputAdjacentProject.addInlineButton(lang.hitch(this, this._onClickOpenAdjacentProjectButton), "openProject", "fas fa-edit");
        //this.inputAdjacentProject.disableInlineButton("openProject");

        this.inputAdjacentProject.addAdditionalRequestParameter("isStayingForAdjacentProject", false);
        this.inputAdjacentProject.on("loaded", lang.hitch(this, this._onLoadAdjacentProjectValues))

        //this.inputIsStayingForAdjacentProject.setReadonly(true);

        this.inputFunctionalSubGroup.setReadonly(true);

        this.createDefaultButton("save", lang.hitch(this, this._onClickSave), false);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TempInvoiceEditor);